import { handleActions } from "redux-actions";
import {
  getRangeOptions,
  getSelectedRangeOption,
  getDateRanges,
  addAllTime,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../../utils/date-range-options";
import {
  SET_LOADING,
  SET_DATES,
  UPDATE_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  SET_TABLES_LOADING,
  SET_REFERRAL_TABLE_LOADING,
  FETCH_FUNNEL_CHART_SUCCESS,
  UPDATE_CUSTOM_RANGE,
  SET_START_FROM,
  ADD_ALL_TIME_RANGE_SUCCESS,
  FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS,
  SET_TOGGLE_LOOSE,
  SET_TOGGLE_FUTURE_APPOINTMENT,
  SET_TOGGLE_EXCLUDE_ENROLLED,
  SET_TOGGLE_REFERRAL_CATEGORY,
  FETCH_REFERRAL_TABLE_SUCCESS,
  SET_AVERAGE,
  SET_AVERAGE_GROUP,
  SET_AVERAGE_LOCATIONS,
  FETCH_FILTERS_SUCCESS,
  UPDATE_PROSPECT_TYPES_SUCCESS,
  SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS,
  SET_AVERAGE_TOOLTIP,
  RESET_FILTERS,
  SET_PROSPECT_TYPES,
  SET_CONTACT_METHOD_FILTERS,
  SET_FIRST_CONTACT_TYPE,
  SET_FILTERS_DIRTY,
  SET_INTRO_OFFER_FILTERS,
  SET_INTRO_OFFER_LOADING,
  SET_PROSPECT_TYPES_LOADING,
  SET_OPT_IN_FILTERS
} from "../sagas/funnelChart";
import FUNNEL_CONSTANTS from "../../constants";
import getFilteredLocations from "../../../../../utils/getFilteredLocations";

const initialState = {
  isLoading: true,
  initialRequest: false,
  currentUser: {},
  tablesLoading: false,
  referralTableLoading: false,
  filtersDirty: false,
  subAverageFilterOptions: {},
  rangeOptions: null,
  contactMethodOptions: [],
  prospectTypes: [],
  introOfferOptions: [],
  introOfferLoading: false,
  prospectTypesLoading: false,
  optInOptions: [],
  selectedFilters: {
    rangeOption: null,
    startFrom: FUNNEL_CONSTANTS.START_FROM_OPTIONS[0],
    average: FUNNEL_CONSTANTS.AVERAGE_OPTIONS[0],
    averageGroup: FUNNEL_CONSTANTS.DEFAULT_GROUP,
    subAverageFilterOptions: [],
    selectedAverageLocations: [],
    toggleLoose: true,
    toggleFutureAppointment: false,
    toggleExcludeEnrolled: false,
    toggleReferralCategory: false,
    prospectTypes: [],
    contactMethodFilters: [],
    firstContactType: FUNNEL_CONSTANTS.FIRST_CONTACT_TYPE_OPTIONS[0],
    introOfferFilters: [],
    optInFilters: []
  },
  averageTooltip: "",
  showGraphWithoutValues: false,
  funnelChartData: {
    chart: {
      values: []
    }
  },
  funnelIntroOffers: {
    primaryStats: [],
    secondaryStats: [],
    combinedStats: [],
    chart: {
      label: "",
      data: {
        values: []
      }
    }
  },
  referralTable: {
    referrals_table: {
      tableInfo: {
        data: []
      }
    }
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_INTRO_OFFER_LOADING]: (state, { payload }) => ({
      ...state,
      introOfferLoading: payload
    }),
    [SET_PROSPECT_TYPES_LOADING]: (state, { payload }) => ({
      ...state,
      prospectTypesLoading: payload
    }),
    [UPDATE_PROSPECT_TYPES_SUCCESS]: (state, { payload }) => ({
      ...state,
      prospectTypes: payload,
      selectedFilters: { ...state.selectedFilters, prospectTypes: payload }
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_START_FROM]: (state, action) => ({
      ...state,
      selectedFilters: { ...state.selectedFilters, startFrom: action.payload }
    }),
    [SET_AVERAGE]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        average: payload,
        averageGroup: FUNNEL_CONSTANTS.DEFAULT_GROUP,
        subAverageFilterOptions: [],
        selectedAverageLocations: state.subAverageFilterOptions.locations || []
      }
    }),
    [SET_AVERAGE_GROUP]: (state, { payload }) => {
      const newGroupItems =
        payload === FUNNEL_CONSTANTS.DEFAULT_GROUP
          ? []
          : state.subAverageFilterOptions[payload] || [];
      return {
        ...state,
        filtersDirty: true,
        selectedFilters: {
          ...state.selectedFilters,
          averageGroup: payload,
          subAverageFilterOptions: newGroupItems,
          selectedAverageLocations:
            state.selectedFilters.average === FUNNEL_CONSTANTS.USER_ACCESS
              ? state.subAverageFilterOptions.locations || []
              : []
        }
      };
    },
    [SET_AVERAGE_LOCATIONS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        selectedAverageLocations: payload
      }
    }),
    [SET_AVERAGE_TOOLTIP]: (state) => ({
      ...state,
      averageTooltip: state.selectedFilters.averageGroup + " Averages"
    }),
    [SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        subAverageFilterOptions: payload,
        selectedAverageLocations:
          state.selectedFilters.average === FUNNEL_CONSTANTS.USER_ACCESS
            ? getFilteredLocations(
                state.subAverageFilterOptions.locations || [],
                state.selectedFilters.averageGroup,
                payload
              )
            : []
      }
    }),
    [SET_TOGGLE_LOOSE]: (state, action) => ({
      ...state,
      selectedFilters: { ...state.selectedFilters, toggleLoose: action.payload }
    }),
    [SET_TOGGLE_FUTURE_APPOINTMENT]: (state, action) => ({
      ...state,
      selectedFilters: { ...state.selectedFilters, toggleFutureAppointment: action.payload }
    }),
    [SET_TOGGLE_EXCLUDE_ENROLLED]: (state, action) => ({
      ...state,
      selectedFilters: { ...state.selectedFilters, toggleExcludeEnrolled: action.payload }
    }),
    [SET_TOGGLE_REFERRAL_CATEGORY]: (state, action) => ({
      ...state,
      selectedFilters: { ...state.selectedFilters, toggleReferralCategory: action.payload }
    }),
    [SET_PROSPECT_TYPES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, prospectTypes: action.payload }
    }),
    [SET_CONTACT_METHOD_FILTERS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, contactMethodFilters: action.payload }
    }),
    [SET_FIRST_CONTACT_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, firstContactType: action.payload }
    }),
    [SET_INTRO_OFFER_FILTERS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, introOfferFilters: payload }
    }),
    [SET_OPT_IN_FILTERS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, optInFilters: action.payload }
    }),
    [SET_TABLES_LOADING]: (state, action) => ({
      ...state,
      tablesLoading: action.payload
    }),
    [SET_REFERRAL_TABLE_LOADING]: (state, action) => ({
      ...state,
      referralTableLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOption(state.currentUser.calendarEndDate)
      },
      rangeOptions: state.rangeOptions || getRangeOptions(state.currentUser.calendarEndDate)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        ...getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload,
          state.funnelChartData.first_data_date
        ),
        rangeOption: action.payload
      },
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOptionWithCustom(action)
      },
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      filtersDirty: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initialRequest: true
    }),
    [FETCH_FUNNEL_CHART_SUCCESS]: (state, { payload: { funnel_laser, first_data_date } }) => ({
      ...state,
      showGraphWithoutValues: state.selectedFilters.average !== FUNNEL_CONSTANTS.AVERAGE_OPTIONS[0],
      funnelChartData: { ...funnel_laser, first_data_date }
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      averageTooltip: initialState.averageTooltip,
      selectedFilters: {
        ...initialState.selectedFilters,
        startFrom: state.selectedFilters.startFrom,
        toggleFutureAppointment: state.currentUser.showFutureAppointmentByDefault,
        prospectTypes: state.prospectTypes,
        contactMethodFilters: state.contactMethodOptions,
        introOfferFilters: state.introOfferOptions,
        optInFilters: state.optInOptions
      },
      referralTable:
        state.selectedFilters.startFrom.id !== "leads"
          ? {
              referrals_table: {
                tableInfo: {
                  data: []
                }
              }
            }
          : state.referralTable
    }),
    [FETCH_REFERRAL_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      referralTable: action.payload
    }),
    [ADD_ALL_TIME_RANGE_SUCCESS]: (state, action) => ({
      ...state,
      rangeOptions: addAllTime(state, action)
    }),
    [FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS]: (state, action) => ({
      ...state,
      funnelIntroOffers: action.payload || state.funnelIntroOffers,
      showGraphWithoutValues: state.selectedFilters.average !== FUNNEL_CONSTANTS.AVERAGE_OPTIONS[0]
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      contactMethodOptions: action.payload.contact_method_options || [],
      prospectTypes: action.payload.prospect_types,
      introOfferOptions: action.payload.intro_offers || state.introOfferOptions,
      optInOptions: action.payload.opt_in_options || [],
      selectedFilters: {
        ...state.selectedFilters,
        prospectTypes: action.payload.prospect_types,
        contactMethodFilters:
          action.payload.contact_method_options || state.selectedFilters.contactMethodFilters,
        introOfferFilters: action.payload.intro_offers || state.selectedFilters.introOfferFilters,
        optInFilters: action.payload.opt_in_options || state.selectedFilters.optInFilters
      },
      subAverageFilterOptions: {
        Division: action.payload?.divisions || [],
        District: action.payload?.districts || [],
        Region: action.payload?.regions || [],
        locations: action.payload?.locations || []
      }
    })
  },
  initialState
);
